module.exports = __webpack_public_path__ + "img/img-8.1f0637bd.png";